module.exports = __webpack_public_path__ + "img/mtznzkxt.1b938db5.jpg";